import { create } from 'zustand';
import type { AuthUser } from '@admitly/shared';

type AuthState = {
  accessToken: string | null;
  user: AuthUser | null;
  setSession: (accessToken: string, user: AuthUser) => void;
  clear: () => void;
};

/**
 * Access token is kept in memory only (no localStorage) so it can't be exfiltrated
 * by XSS. Persistence comes from the HttpOnly refresh cookie on /api/v1/auth.
 *
 * The cookie is sent automatically by the browser on /api/v1/auth/refresh.
 */
export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  user: null,
  setSession: (accessToken, user) => set({ accessToken, user }),
  clear: () => set({ accessToken: null, user: null }),
}));
